import Event from './Event';
let EventCenter = new Event();
export default EventCenter;
